import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.css'],
    standalone: false
})

export class NewsComponent implements OnInit {
  news: any[] = [];
  createdAt: any[] = [];
  filter = 1;
  loading = true;
  loaders = Array(10).fill(0);

  constructor(private dashboardService: DashboardService,
              private router: Router
  ) {
  }

  ngOnInit(): void {
    this.getNews();
  }

  getNews(): void {
    this.dashboardService.getNewsArticles({type: this.filter}).subscribe(res => {
      this.news = res?.response || [];
      this.loading = false;
      this.getTime();
    }, (err => {
      this.loading = false;
    }));
  }

  remove(id: string): void {
    this.dashboardService.removeArticle(id).subscribe(res => {
      this.getNews();
    });
  }

  getTime(): void {
    this.createdAt = this.news.map((e) => {
      return new Date(e.createdAt).toLocaleString();
    });
  }

}
